import { SnackBarService } from "./../../../../services/common/snackBar.service";
import { FormGroup } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";

import { TranslateService } from "@ngstack/translate";
import { ICourseType } from "src/app/interfaces/course-type";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSelectChange
} from "@angular/material";
import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
import { ICoursePattern } from "src/app/interfaces/coursePattern";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CIDService } from "src/app/services/common/cid.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-course-pattern-entry",
  templateUrl: "./course-pattern-entry.component.html",
  styleUrls: ["./course-pattern-entry.component.css"]
})
export class CoursePatternEntryComponent implements OnInit {
  form: FormGroup;
  compnayList: ICompany;
  companySelected: string;
  courseTypeList: ICourseType;
  sessionDuration: number[] = [];
  sessionPerDays: any[] = [
    { Id: 1, Title: this.translate.get("label.oneSession") },
    { Id: 2, Title: this.translate.get("label.twoSession") },
    { Id: 3, Title: this.translate.get("label.threeSession") }
  ];

  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  isOwner: boolean;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private courseTypeService: CourseTypeService,
    private coursePatternService: CoursePatternService,
    private dialogRef: MatDialogRef<CoursePatternEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICoursePattern
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createForm();

    this.setSessionDuration();
    this.companySelected = this.cidService.getCID();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        if (this.cidService.getCID())
          this.loadCourseTypeList();
      }
      else {
        this.loadCourseTypeList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.compnayList = res.DataList;
    });
  }

  setCid(e: MatSelectChange) {
    this.cidService.setCID(e.value);
    this.loadCourseTypeList();
  }

  createForm() {
    this.form = this.fb.group({
      CourseTypeId: [
        this.data && this.data.CourseTypeId
          ? this.data.CourseTypeId.toString()
          : null,
        Validators.compose([Validators.required])
      ],
      Title: [this.data && this.data.Title ? this.data.Title : null],
      SessionQty: [
        this.data && this.data.SessionQty ? this.data.SessionQty : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(120)
        ])
      ],
      SessionDuration: [
        this.data && this.data.SessionDuration
          ? this.data.SessionDuration.toString()
          : null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(600)
        ])
      ],
      ContainDiscount: [
        this.data && this.data.ContainDiscount ? this.data.ContainDiscount : 0
      ],
      // IsActive: [this.data && this.data.IsActive ? this.data.IsActive : 0],
      Saturday: [this.data && this.data.Saturday ? this.data.Saturday : 0],
      Sunday: [this.data && this.data.Sunday ? this.data.Sunday : 0],
      Monday: [this.data && this.data.Monday ? this.data.Monday : 0],
      Tuesday: [this.data && this.data.Tuesday ? this.data.Tuesday : 0],
      Wednesday: [this.data && this.data.Wednesday ? this.data.Wednesday : 0],
      Thursday: [this.data && this.data.Thursday ? this.data.Thursday : 0],
      Friday: [this.data && this.data.Friday ? this.data.Friday : 0],
      SessionCount: [
        this.data && this.data.SessionCount
          ? this.data.SessionCount.toString()
          : null,
        Validators.compose([Validators.required])
      ],
      Id: [this.data && this.data.Id ? this.data.Id : 0],
      BreakTime: [
        this.data && this.data.BreakTime ? this.data.BreakTime : null,
        Validators.compose([
          Validators.required,
          Validators.min(5),
          Validators.max(30)
        ])
      ]
    });
  }

  loadCourseTypeList() {
    this.courseTypeService.list(0, 0).subscribe(
      res => {
        this.courseTypeList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setSessionDuration() {
    for (let i = 15; i <= 195; i = i + 15) {
      this.sessionDuration.push(i);
    }
  }

  submit(form: ICoursePattern) {
    this.errors = new Array();
    if (form.Id == 0) {
      this.coursePatternService.add(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      ),
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        };
    } else {
      this.coursePatternService.edit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.registration"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close();
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
